import { SkipNav } from '@ver-uds/uswds-react';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import ReactGA from 'react-ga4';
import { useLogout } from '@vis-auth/react';
import { EveRoutes } from '@ver-uds/e-verify';

const DashboardAccountNotFound = (): JSX.Element => {
  const logout = useLogout();

  const handleLogout = (e: React.MouseEvent<HTMLElement>): void => {
    e.preventDefault();
    logout();
  };

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname + window.location.search,
      pageTitle: 'E-Verify - Verify Your User Account',
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Dashboard - Verify Your User Account</title>
      </Helmet>
      <div className="grid-container margin-top-4 margin-bottom-4">
        <div className="grid-row">
          <div className="grid-col">
            <SkipNav.MainContent>
              <h1>Verify Your User Account</h1>
              <h3>We were unable to locate an account associated with your Login.gov email.</h3>
              <ul>
                <li>
                  <strong>New User?</strong> Please contact your program administrator for assistance.
                </li>
                <li>
                  <strong>Have an existing account?</strong>{' '}
                  <a
                    href={window.location.origin + EveRoutes.LOGIN}
                    aria-label="Click here to visit the legacy login page"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e): void => handleLogout(e)}
                  >
                    Sign in with your user name and password.
                  </a>{' '}
                  Then follow the link on the home page to migrate your user account to Login.gov.
                </li>
              </ul>
            </SkipNav.MainContent>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardAccountNotFound;
